import PropTypes from 'prop-types'
import styled from 'styled-components'

import Container from '../Container'
import IconList from '../IconList'
import CTA from '../CTA'
import Display from '../Display'

const Benefits = ({ data, defaultData, ctaHref }) => {
  const {
    primary: {
      headline
    },
    items,
  } = data
  const {
    primary: {
      headline: defaultHeadline,
      button_tip: buttonTip,
    }
  } = defaultData

  return (
    <Wrapper center>
      <StyledDisplay size="small" element="h2">{headline[0]?.text || defaultHeadline[0]?.text}</StyledDisplay>

      <StyledIconList items={items} descMaxWidth={'300px'} />

      <StyledCTA
        align={'center'}
        buttonColor="azure"
        buttonTip={buttonTip}
        buttonHref={ctaHref}
      />
    </Wrapper>
  )
}

const StyledDisplay = styled(Display)`
  margin: 0 0 80px;
`

const StyledIconList = styled(IconList)`
  margin-bottom: 20px;
`

const StyledCTA = styled(CTA)`
  a {
    width: 320px;

    @media screen and (max-width: ${ (props) => props.theme.breakpoints.xs1 }) {
      width: 100%;
      padding: 20px;
    }
  }
`

const Wrapper = styled(Container)`
  align-items: center;
  background-color: ${ (props) => props.theme.colors.chartreuse[3] };
`

Benefits.defaultProps = {
  ctaHref: null,
}

Benefits.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  defaultData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  ctaHref: PropTypes.string,
}

export default Benefits
